import React from 'react';
import { Eye, X } from '../../icons';

const ImpersonationBanner = ({ impersonatedUser, onStopImpersonation }) => {
  if (!impersonatedUser) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-amber text-[#2A1C00] px-4 py-2 shadow-lg pt-safe">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0 text-sm">
          <Eye className="w-5 h-5 flex-shrink-0" />
          <span className="font-semibold truncate">
            Viewing as: {impersonatedUser.displayName}
            {impersonatedUser.email && <span className="font-normal ml-1 opacity-80">({impersonatedUser.email})</span>}
          </span>
        </div>
        <button
          type="button"
          onClick={onStopImpersonation}
          className="flex items-center gap-1.5 h-9 px-3 bg-[#2A1C00]/15 hover:bg-[#2A1C00]/25 rounded-lg text-sm font-semibold whitespace-nowrap"
        >
          <X className="w-4 h-4" />
          Stop
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
